<template>
    <div class="betslip-selection__list responsive__element">
        <div class="betslip-selection__list-wrapper">
            <div
                v-for="selection in selections"
                :key="selection.eventId"
                class="betslip-selection__item"
            >
                <SelectionReadOnly v-bind="selection" />
            </div>
        </div>
    </div>
</template>

<script>
    import { twoDecimals } from '@shared/filters';
    import { createSportSelection, createSpecialSelection } from '@app/utils/mappers/TicketEventToSelectionProps';
    import { isSpecialEvent } from '@core/models/specials/SpecialEvent';
    import SelectionReadOnly from './SelectionReadOnly';

    export default {
        name: 'OfflineSportTicket',
        props: {
            events: {
                type: Array,
                required: true,
            },
        },
        created() {
            this.twoDecimals = twoDecimals;
        },
        computed: {
            selections() {
                return this.events.map((ticketEvent) => {
                    if (ticketEvent.eventId && isSpecialEvent(ticketEvent.eventId)) {
                        return createSpecialSelection(ticketEvent);
                    }
                    return createSportSelection(ticketEvent);
                });
            },
        },
        components: {
            SelectionReadOnly,
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/tickets/OfflineSportTicket.vue